<template>
	<div class="page-in">
		<van-nav-bar :title="$t('我的团队')" fixed placeholder left-arrow z-index="99" @click-left="back" :border="false"
			v-if="isMobileFlag" />
		<div class="inside-page">
			<div class="layui-container" v-if="$store.state.userInfo">
				<div class="breadcrumb" v-if="!isMobileFlag">
					<el-link type="info" @click="back">
						<span class="iconfont icon-l-left"></span><span>{{$t('返回')}}</span>
					</el-link>
				</div>
				<div class="agency-panel">
					<div class="agency-grid">
						<div class="head-avatar">
							<img :src="$store.state.userInfo.avatar && $store.state.userInfo.avatar != '' ? $store.state.userInfo.avatar : require('@/assets/images/head.png')" alt="" />
						</div>
						<div class="flex-col">
							<div class="t-name">
								<span>{{$store.state.userInfo.user_name}}</span>
								<span class="vip-tag">
									<span
										class="iconfont icon-crown"></span><span>{{$store.state.userInfo.level_name}}</span>
								</span>
							</div>
							<div class="t-value">
								<span>{{$t('当前等级返利率')}}：{{$store.state.userInfo.proportion}}% </span>
								<span class="iconfont icon-wentidingdan btn-tip" @click="showRebate"></span>
							</div>
						</div>
					</div>
					<div class="agency-data">
						<div class="col">
							<div class="agency-label">{{$t('总返积分')}}</div>
							<div class="agency-val">{{ formatNumber($store.state.userInfo.total_rebate) }} </div>
						</div>
						<div class="col">
							<div class="agency-label">{{$t('本周返积分')}}</div>
							<div class="agency-val">{{ formatNumber($store.state.userInfo.week_consumption) }} </div>
						</div>
						<div class="col">
							<div class="agency-label">{{$t('昨日返积分')}}</div>
							<div class="agency-val">{{ formatNumber($store.state.userInfo.yesterday_consumption) }} </div>
						</div>
					</div>
				</div>
				<div class="agency-cell">
					<div class="agency-cell-head">
						<div class="agency-cell-head-title">{{$t('我的代理团队')}}</div>
						<a href="javascript:;" class="agency-link text-primary" @click="showProxy">
							{{$t('代理说明')}}
						</a>
					</div>
					<el-table class="el-my-table" :data="tableData" border style="width: 100%">
						<el-table-column prop="member" :label="$t('团队成员')" align="center" min-width="190">
							<template slot-scope="scope">
								<div class="flex-center" style="margin: 0;">
									<img src="../../assets/images/team.png" style="width: 20px;margin-right: 10px;"
										alt="" /><span>{{ $t(scope.row.member) }}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="number" :label="$t('人数')" min-width="120" align="center">
						</el-table-column>
						<el-table-column prop="consume" :label="$t('今日消费')" align="center" min-width="190">
							<template slot-scope="scope">
								{{ formatNumber(scope.row.consume) }} VND
							</template>
						</el-table-column>
						<el-table-column prop="refund" :label="$t('等级返利率')" align="center" min-width="190">
							<template slot-scope="scope">
								{{ scope.row.refund }}%
							</template>
						</el-table-column>
						<el-table-column prop="commission" :label="$t('返利积分')" align="center" min-width="190">
							<template slot-scope="scope">
								{{ formatNumber(scope.row.commission) }}
							</template>
						</el-table-column>
						<el-table-column prop="total_price" :label="$t('累计消费金额')" align="center" min-width="190">
							<template slot-scope="scope">
								{{ formatNumber(scope.row.total_price) }}
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="agency-cell" v-if="tableMyTeam && tableMyTeam.length > 0">
					<div class="agency-cell-head">
						<div class="agency-cell-head-title">{{$t('我的代理团队')}}</div>
					</div>
					<div class="agency-sub-head-title">
						<img src="../../assets/images/team.png" alt="" /><span>{{$t('直属下级')}}</span>
					</div>
					<el-table class="el-my-table" :data="tableMyTeam" border style="width: 100%">
						<el-table-column prop="user_name" :label="$t('昵称')" align="center" min-width="190">
						</el-table-column>
						<el-table-column prop="level_name" :label="$t('会员等级')" align="center" min-width="190">
						</el-table-column>
						<el-table-column prop="day_price" :label="$t('今日消费')" align="center" min-width="190">
							<template slot-scope="scope">
								{{ formatNumber(scope.row.day_price) }} VND
							</template>
						</el-table-column>
						<el-table-column prop="create_time" :label="$t('加入团队日期')" align="center" min-width="190">
						</el-table-column>
						<el-table-column prop="rebate_price" :label="$t('返利积分')" align="center" min-width="190">
							<template slot-scope="scope">
								{{ formatNumber(scope.row.rebate_price) }}
							</template>
						</el-table-column>
						<el-table-column prop="total_price" :label="$t('累计消费金额')" align="center" min-width="190">
							<template slot-scope="scope">
								{{ formatNumber(scope.row.total_price) }}
							</template>
						</el-table-column>
					</el-table>
					<div class="page-footer">
						<el-pagination background :small="isMobileFlag" :pager-count="5" layout="prev, pager, next"
							:current-page.sync="currentPage" @current-change="handleSizeChange" :page-size="listLimit"
							:total="listTotal"></el-pagination>
					</div>
				</div>
				<div class="agency-team-main" v-if="$store.state.userInfo">
					<div class="agency-team-hd">{{$t('邀请朋友加入团队')}}</div>
					<el-row :gutter="30" class="agency-row">
						<el-col :xs="24" :md="24" :lg="10">
							<div class="invte-row mb-10">
								<div class="invte-label">{{$t('邀请码')}}：</div>
								<div class="flex-col">
									<input type="text" id="invteCode" readonly="" class="el-input__inner"
										:value="$store.state.userInfo.invite_code">
								</div>
								<div class="iconfont icon-fuzhi" v-clipboard:copy="$store.state.userInfo.invite_code"
									v-clipboard:success="onCopy"></div>
							</div>
							<!-- <div class="invte-row">
								<div class="invte-label">邀请链接：</div>
								<div class="flex-col">
									<input type="text" id="invteUrl" readonly="" class="el-input__inner"
										value="https://www.baidu.com/">
								</div>
								<div class="iconfont icon-fuzhi" v-clipboard:copy="invite_url"
									v-clipboard:success="onCopy"></div>
							</div> -->
							<div class="agency-desc">
								{{$t('邀请码提示')}}
							</div>
							<!-- <div class="form-share">
								<a href="" class="form-share-link">
									<span class="iconfont icon-facebook"></span>
								</a>
								<a href="" class="form-share-link">
									<span class="iconfont icon-telegram"></span>
								</a>
								<a href="" class="form-share-link">
									<span class="iconfont icon-insgram"></span>
								</a>
							</div> -->
						</el-col>
						<el-col :xs="24" :md="12" :lg="8">
							<div class="invte-row invte-date-row">
								<div class="invte-label">{{$t('下单时间')}}： </div>
								<div class="flex-col">
									<el-date-picker v-model="daterange" type="daterange" range-separator="-"
										:start-placeholder="$t('开始日期')" :end-placeholder="$t('结束日期')" v-if="!isMobileFlag">
									</el-date-picker>
									<div class="el-m-data" @click="mShow = true" v-else>
										<div class="data-placholder" v-if="mDaterange == ''">
											{{$t('开始日期')}} - {{$t('结束日期')}}
										</div>
										<span v-else>{{mDaterange}}</span>
									</div>
								</div>
							</div>
							<div class="invte-bar">{{$t('已邀请人数')}}：{{$store.state.userInfo.leader1_count}}</div>
							<div class="invte-bar">{{$t('成功加入人数')}}：{{$store.state.userInfo.success_leader1_count}}</div>
							<div class="invte-bar">{{$t('今日加入人数')}}：{{$store.state.userInfo.day_leader1_count}}</div>
						</el-col>
						<el-col :xs="24" :md="12" :lg="6" v-if="!isMobileFlag">
							<div class="invte-pic"><img src="@/assets/images/yqpic.png" alt=""></div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<RebateDialog :levelList="RebateData" ref="Rebate"></RebateDialog>
		<ProxyDialog ref="Proxy"></ProxyDialog>
		<van-calendar  :confirm-text="$t('确定')" v-model="mShow"  color="#8B6E35" type="range" @confirm="onConfirm" :show-subtitle="false" />
	</div>
</template>
<script>
	import { Locale } from 'vant';
	import viVN from 'vant/es/locale/lang/vi-VN';
	import {
		user_team_lis_api,
		user_level_list_api
	} from "@/api/user"
	import Cooperation from '../Home/components/Cooperation.vue'
	import RebateDialog from './components/RebateDialog'
	import ProxyDialog from './components/ProxyDialog'
	export default {
		components: {
			Cooperation,
			ProxyDialog,
			RebateDialog
		},
		data() {
			return {
				rec_code: '1111112222',
				invite_url: '1111112222',
				daterange: "",
				tableData: [{
					member: '直属下级',
					number: this.$store.state.userInfo.leader1_count,
					consume: this.$store.state.userInfo.day_tree_price,
					refund: this.$store.state.userInfo.proportion,
					commission: this.$store.state.userInfo.total_rebate,
					total_price: this.$store.state.userInfo.tree_total_price,
				}, ],
				tableMyTeam: [],
				mDaterange: '',
				mShow: false,
				currentPage: 1,
				listPage: 1,
				listLimit: 10,
				listTotal: 0,
				RebateData: [],
			};
		},
		methods: {
			showRebate() {
				this.$refs.Rebate.show = true
			},
			showProxy() {
				this.$refs.Proxy.show = true
			},
			formatDate(date) {
				return `${date.getMonth() + 1}/${date.getDate()}`;
			},
			onConfirm(date) {
				const [start, end] = date;
				this.mShow = false;
				this.mDaterange = `${this.formatDate(start)} - ${this.formatDate(end)}`;
			},
			onCopy: function() {
				this.successTips('Copy success');
			},
			async getTeamList() {
				let data = {
					page: this.listPage,
					limit: this.listPage == 1 ? 10 : this.listLimit,
				};
				await user_team_lis_api(data).then(res => {
					console.log(res.data,'res.datares.data')
					if (res && res.data.code == 1) {
						this.tableMyTeam = res.data.data.list
						this.listTotal = res.data.data.total;
					} else if(res && res.data.code == -1){
						this.goLogin()
					}
				});
			},
			async getLevelList() {
				await user_level_list_api().then(res => {
					if (res && res.data.code == 1) {
						this.RebateData = res.data.data
					}
				});
			},
			handleSizeChange(e) {
				this.listPage = e;
				this.getTeamList();
			}
		},
		mounted() {
			this.getTeamList()
			this.getLevelList()
			this.isCheckLogin()
		}
	}
</script>